import { atom } from "jotai";

export const intentToCloseAtom = atom<boolean>(false);
